import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import UsernameSection from './Components/UsernameSection';
import EmailSection from './Components/EmailSection';
import PasswordSection from './Components/PasswordSection';

import './Account.scss';

const spinnerId = 'profile-settings-account';

function Account(props) {
  const {
    username,
    email,
    changeEmail,
    saveEmail,
    init,
    resetEmail,
    trackAdobeAnalyticsEmailError,

    savePassword,
    setPasswordData,
    passwordData,
    resetPassword,
    restrictedWords,
    trackAdobeAnalyticsPasswordError,

    isShibboleth,
    isLoading,
  } = props;

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    init();
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className="rx-accordion rx-accordion--large profile-settings-accordion account-accordion"
      role="form"
      aria-label="Account Settings">
      <div>
        {isLoading && <SimpleSpinner id={spinnerId} />}
        <UsernameSection value={username} />
        <EmailSection
          value={email}
          onChange={changeEmail}
          onSave={saveEmail}
          onClose={resetEmail}
          trackAdobeAnalyticsError={trackAdobeAnalyticsEmailError}
        />
        {!isShibboleth && (
          <PasswordSection
            value={passwordData}
            onChange={setPasswordData}
            onSave={savePassword}
            onClose={resetPassword}
            restrictedWords={restrictedWords}
            trackAdobeAnalyticsError={trackAdobeAnalyticsPasswordError}
          />
        )}
      </div>
    </div>
  );
}

Account.propTypes = {
  username: PropTypes.string,
  email: PropTypes.string,
  changeEmail: PropTypes.func.isRequired,
  saveEmail: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  resetEmail: PropTypes.func.isRequired,
  trackAdobeAnalyticsEmailError: PropTypes.func.isRequired,
  savePassword: PropTypes.func.isRequired,
  setPasswordData: PropTypes.func.isRequired,
  passwordData: PropTypes.shape({
    password: PropTypes.string,
    newPassword: PropTypes.string,
    confirmPassword: PropTypes.string,
  }),
  resetPassword: PropTypes.func.isRequired,
  restrictedWords: PropTypes.arrayOf(PropTypes.string),
  trackAdobeAnalyticsPasswordError: PropTypes.func.isRequired,
  isShibboleth: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Account;
